import API from './API'
const route = 'transaction/'

export default class Transaction {
  getList(params) {
    return API.get(`${route}list`, { params })
  }
  getDetail(id, task) {
    return API.get(`${route}${id}/?task=${task}`)
  }
  // getMonthlyStatistic(params){
  //   return API.post(`${route}monthlystatistics`,params)
  // }
  getMonthlyStatistic(date) {
    return API.get(`/bill/statistics?date=${date}`)
  }
  async updateTransaction(params) {
    return await API.put(`updatetransaction`, params)
      .then((data) => {
        return data
      })
      .catch((err) => {
        return {
          result: false,
          message: err,
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/libs/Transaction.js